import React, { useState } from "react";
import Navigation from "../Navigation/Navigation";
import {
  MdKeyboardArrowLeft,
  MdEast,
  MdOutlineBorderColor,
  MdRemoveRedEye,
} from "react-icons/md";
import {
  Image,
  Container,
  Col,
  Row,
  Button,
  InputGroup,
  img,
} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import profile from "../../assets/profile.png";
import { Link } from "react-router-dom";
import { FaEyeSlash, FaEye } from "react-icons/fa";
import ErrorLabel from "../../Components/ErrorLabel/ErrorLabel";
import {
  ConfirmPasswordCheck,
  CreatePasswordCheck,
} from "../../ConditionChecks/ConditionChecks";

const MyProfileResetPassword = (props) => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [visibleOldPassword, setVisibleOldPassword] = useState(true);
  const [visibleNewPassword, setVisibleNewPassword] = useState(false);
  const [visibleConfirmPassword, setVisibleConfirmPassword] = useState(false);

  const [errDisplayOldPassword, seterrDisplayOldPassword] = useState("");
  const [errDisplayNewPassword, seterrDisplayNewPassword] = useState("");
  const [errDisplayConfirmPassword, seterrDisplayConfirmPassword] =
    useState("");

  const onOldPassword = (e) => {
    setOldPassword(e.target.value);
  };

  const onNewPassword = (e) => {
    setNewPassword(e.target.value);
  };

  const onConfirmPassword = (e) => {
    setConfirmPassword(e.target.value);
  };

  const OldPasswordVisibleHandler = () => {
    setVisibleOldPassword(false);
  };
  const OldPasswordNotVisibleHandler = () => {
    setVisibleOldPassword(true);
  };

  const NewPasswordVisibleHandler = () => {
    setVisibleNewPassword(false);
  };
  const NewPasswordNotVisibleHandler = () => {
    setVisibleNewPassword(true);
  };

  const ConfirmPasswordVisibleHandler = () => {
    setVisibleConfirmPassword(false);
  };
  const ConfirmPasswordNotVisibleHandler = () => {
    setVisibleConfirmPassword(true);
  };

  const CancelHandler = () => {
    window.location.href = "/my-profile";
  };

  const ResetPasswordSaveHandler = (e) => {
    e.preventDefault();
    const NewPasswordValidation = CreatePasswordCheck(newPassword);
    const ConfirmPasswordValidation = ConfirmPasswordCheck(
      newPassword,
      confirmPassword
    );
    let OldPasswordValidation = true;

    if (!oldPassword) {
      seterrDisplayOldPassword("Old passwords is required!");
      OldPasswordValidation = false;
    }

    if (NewPasswordValidation.input === "empty") {
      seterrDisplayNewPassword(NewPasswordValidation.err_display);
    } else if (NewPasswordValidation.input === "lesscharacters") {
      seterrDisplayNewPassword(NewPasswordValidation.err_display);
    } else if (NewPasswordValidation.input === "invalid") {
      seterrDisplayNewPassword(NewPasswordValidation.err_display);
    }

    if (ConfirmPasswordValidation.input === "empty") {
      seterrDisplayConfirmPassword(ConfirmPasswordValidation.err_display);
    } else if (ConfirmPasswordValidation.input === "deosnotmatch") {
      seterrDisplayConfirmPassword(ConfirmPasswordValidation.err_display);
    }

    if (OldPasswordValidation === true) {
      seterrDisplayOldPassword("");
    }

    if (NewPasswordValidation.validition === true) {
      seterrDisplayNewPassword("");
    }

    if (ConfirmPasswordValidation.validition === true) {
      seterrDisplayConfirmPassword("");
    }

    if (
      NewPasswordValidation.validition &&
      ConfirmPasswordValidation.validition &&
      OldPasswordValidation === true
    ) {
      let ResetPasswordData = {
        old_Password: oldPassword,
        new_Password: newPassword,
        confirm_Password: confirmPassword,
      };

      setOldPassword("");
      setNewPassword("");
      setConfirmPassword("");

      seterrDisplayOldPassword("");
      seterrDisplayNewPassword("");
      seterrDisplayConfirmPassword("");
    }
  };

  return (
    <>
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <Navigation />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <p className="page-text dashboard">
            <Link>
              <MdKeyboardArrowLeft className="arrow-left" />
              Back
            </Link>
          </p>
          <p className="page-maintitle">Reset Password</p>
          <div className="white-bg mt-4 py-5">
            <Row>
              <Col md="4"></Col>
              <Col md="4">
                <Form
                  onSubmit={ResetPasswordSaveHandler}
                  className="formmain mx-5 mb-3 signin-row"
                >
                  <Row className="forgot_Password_Row">
                    <Col md="12" className="mt-3">
                      <Form.Label className="form-label-custom edit-sec">
                        Old Password
                      </Form.Label>
                      <InputGroup className="mb-3 edit-border">
                        <div className="position-relative">
                          <Form.Control
                            type={visibleOldPassword === true ? "" : "password"}
                            placeholder="Enter Old Password"
                            aria-label="Recipient's username"
                            aria-describedby="basic-addon2"
                            onChange={onOldPassword}
                            value={oldPassword}
                          />
                          {visibleOldPassword === true ? (
                            <Button
                              variant="outline-secondary"
                              className="edit-mainn px-2"
                              onClick={OldPasswordVisibleHandler}
                            >
                              <FaEyeSlash className="eye-icon" />
                            </Button>
                          ) : (
                            <Button
                              variant="outline-secondary"
                              className="edit-mainn px-2"
                              onClick={OldPasswordNotVisibleHandler}
                            >
                              <FaEye className="eye-icon" />
                            </Button>
                          )}
                        </div>
                      </InputGroup>
                      <ErrorLabel ErrorDisplay={errDisplayOldPassword} />
                    </Col>
                    <Col md="12" className="mt-3">
                      <Form.Label className="form-label-custom edit-sec">
                        New Password
                      </Form.Label>
                      <InputGroup className="mb-3 edit-border">
                        <div className="position-relative">
                          <Form.Control
                            type={visibleNewPassword === true ? "" : "password"}
                            placeholder="Enter New Password"
                            aria-label="Recipient's username"
                            aria-describedby="basic-addon2"
                            onChange={onNewPassword}
                            value={newPassword}
                          />
                          {visibleNewPassword === true ? (
                            <Button
                              variant="outline-secondary"
                              className="edit-mainn px-2"
                              onClick={NewPasswordVisibleHandler}
                            >
                              <FaEyeSlash className="eye-icon" />
                            </Button>
                          ) : (
                            <Button
                              variant="outline-secondary"
                              className="edit-mainn px-2"
                              onClick={NewPasswordNotVisibleHandler}
                            >
                              <FaEye className="eye-icon" />
                            </Button>
                          )}
                        </div>
                      </InputGroup>
                      <ErrorLabel ErrorDisplay={errDisplayNewPassword} />
                    </Col>
                    <Col md="12" className="mt-3">
                      <Form.Label className="form-label-custom edit-sec">
                        Confirm Password
                      </Form.Label>
                      <InputGroup className="mb-3 edit-border">
                        <div className="position-relative">
                          <Form.Control
                            type={
                              visibleConfirmPassword === true ? "" : "password"
                            }
                            placeholder="Re-enter new password"
                            aria-label="Recipient's username"
                            aria-describedby="basic-addon2"
                            onChange={onConfirmPassword}
                            value={confirmPassword}
                          />
                          {visibleConfirmPassword === true ? (
                            <Button
                              variant="outline-secondary"
                              className="edit-mainn px-2"
                              onClick={ConfirmPasswordVisibleHandler}
                            >
                              <FaEyeSlash className="eye-icon" />
                            </Button>
                          ) : (
                            <Button
                              variant="outline-secondary"
                              className="edit-mainn px-2"
                              onClick={ConfirmPasswordNotVisibleHandler}
                            >
                              <FaEye className="eye-icon" />
                            </Button>
                          )}
                        </div>
                      </InputGroup>
                      <ErrorLabel ErrorDisplay={errDisplayConfirmPassword} />
                    </Col>
                  </Row>
                  <div className="password_Label_Div">
                    <span className="password_Label">
                      (Create a strong password with a mix of upper case
                      letters, alphanumeric and symbols containing at least 8
                      characters.)
                    </span>
                  </div>
                  <div className="text-center reset-btns">
                    <Button
                      variant="primary"
                      type="submit"
                      className="green-btn mt-3"
                    >
                      Save
                    </Button>
                    <p className="mt-4 view-btn">
                      <Link
                        to="/myprofile-resetpadssword"
                        className="redeem-resend "
                      >
                        Cancel
                      </Link>
                    </p>
                  </div>
                </Form>
              </Col>
              <Col md="4"></Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  );
};

export default MyProfileResetPassword;
